import React from 'react';
export function TechnicalSpecsSection() {
  const specs = [{
    label: 'Power',
    value: 'Corded electric (no batteries)'
  }, {
    label: 'Hose Length',
    value: '75 feet'
  }, {
    label: 'Spray Control',
    value: 'Trigger-controlled wand'
  }, {
    label: 'Pressure',
    value: 'Automatic shutoff at 60 PSI'
  }, {
    label: 'Intake System',
    value: 'External siphon'
  }, {
    label: 'Applications',
    value: 'Mold, disinfecting, antimicrobials, degreasers'
  }];
  return <section className="py-16 bg-brand-light" data-id="element-793">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-794">
        <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-795">
          Technical Specifications
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-796">
          {specs.map((spec, index) => <div key={index} className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-797">
              <div className="font-bold text-brand-dark mb-2" data-id="element-798">{spec.label}</div>
              <div className="text-gray-600" data-id="element-799">{spec.value}</div>
            </div>)}
        </div>
      </div>
    </section>;
}